<div class="forgot-password-page mat-typography custom-input flex-column justify-between align-stretch">
  <!-- Signin page Header-->
  <div class="forgot-password-page-header full-size flex-1">
    <!-- Header-->
    <app-header imageUrl="./assets/imgs/backgrounds/signin.jpg">
      <!-- back button-->
      <app-back-button [stopNavigation]="true"
                       (goBack)="cancel()"></app-back-button>
    </app-header>
  </div>

  <!-- form container-->
  <div class="forgot-password-container centered">
    <app-forgot-password (forgotPassword)="forgotPassword($event)"
                         (cancel)="cancel()"
                         [submitting]="submitting"></app-forgot-password>
  </div>
</div>
